import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Container, Divider, IconButton, Link, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Mail, Phone } from 'lucide-react';
import { Logo } from 'src/components/logo';
import { secondary } from 'src/theme';

const LINKS = [
  {
    headline: 'Layanan',
    children: [
      { name: 'Bus AKAP', href: '/bus-akap' },
      { name: 'Bus Pariwisata', href: '/bus-pariwisata' },
    ],
  },
  {
    headline: 'Agen',
    children: [
      { name: 'Sumatera Selatan', href: '/agen/?search=Sumatera Selatan' },
      { name: 'Lampung', href: '/agen/?search=Lampung' },
      { name: 'Banten', href: '/agen/?search=Banten' },
      { name: 'Jawa Barat', href: '/agen/?search=Jawa Barat' },
      { name: 'Jawa Tengah', href: '/agen/?search=Jawa Tengah' },
      { name: 'Yogyakarta (D.I.Y', href: '/agen/?search=Yogyakarta' },
      { name: 'Jawa Timur', href: '/agen/?search=Jawa Timur' },
    ],
  },
  {
    headline: 'Panduan',
    children: [
      { name: 'Pemesanan Tiket', href: '#' },
      { name: 'Reservasi', href: '#' },
      { name: 'Kebijakan Privasi', href: '/kebijakan-privasi' },
    ],
  },
];

export function MainFooter() {
  return (
    <>
      <Box
        sx={{
          height: { xs: '70px', md: '100px', lg: '140px' },
          width: '100%',
          background: 'url("/assets/background/background-footer-top.svg")',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom',
        }}
      />
      <Box
        sx={{
          background: 'var(--grey-900, #141A21)',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            padding: {
              xs: '40px 0px 20px 0px',
              md: 'var(--spacing-10, 80px) 0px var(--spacing-5, 40px) 0px',
            },
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--spacing-10, 80px)',
            overflow: 'hidden',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: { xs: 0, md: '-250px' },
              right: '-150px',
              width: '600px',
              height: '600px',
              backgroundImage: 'url("/logo/logo-single.png")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              opacity: 0.1,
              zIndex: 1,
            },
          }}
        >
          <Container>
            <Box sx={{ position: 'relative', zIndex: 3 }}>
              <Grid
                container
                direction={{ xs: 'column', md: 'row' }}
                alignItems={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                gap={{ xs: 5, md: 0 }}
              >
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    alignItems={{
                      xs: 'center',
                      md: 'flex-start',
                    }}
                  >
                    <div className="w-[300px]">
                      <Logo
                        height={55}
                        sx={{
                          marginBottom: '24px',
                        }}
                      />
                    </div>
                    <Box
                      sx={{
                        paddingTop: '24px',
                        paddingBottom: '40px',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        component="span"
                        sx={{ color: 'white', textAlign: { xs: 'center', md: 'left' } }}
                      >
                        Head Office
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'white', textAlign: 'left' }}>
                        Jl. Soekarno Hatta No. 3 Rajabasa, <br />
                        Bandar Lampung, Lampung, Indonesia
                      </Typography>
                    </Box>
                    <Grid container direction="row">
                      <Grid>
                        <IconButton
                          component="a"
                          href="https://linkedin.com/company/puspajayatransport"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Kunjungi akun Linkedin Puspajaya (opens di tab baru)"
                        >
                          <Icon icon="mdi:linkedin" />
                        </IconButton>
                      </Grid>
                      <Grid>
                        <IconButton
                          component="a"
                          href="https://www.instagram.com/puspajaya.transport/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Kunjungi akun Instagram Puspajaya (opens di tab baru)"
                        >
                          <Icon icon="mdi:instagram" />
                        </IconButton>
                      </Grid>
                      <Grid>
                        <IconButton
                          component="a"
                          href="https://www.tiktok.com/@puspajaya.transport"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Kunjungi akun Tiktok Puspajaya (opens di tab baru)"
                        >
                          <Icon icon="ic:baseline-tiktok" />
                        </IconButton>
                      </Grid>
                      <Grid>
                        <IconButton
                          component="a"
                          href="https://www.facebook.com/share/1DzUzedK3w/?mibextid=wwXIfr"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Kunjungi akun Facebook Puspajaya (opens di tab baru)"
                        >
                          <Icon icon="ic:baseline-facebook" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Grid
                    container
                    direction={{ xs: 'column', md: 'row' }}
                    sx={{
                      justifyContent: 'flex-end',
                      alignItems: {
                        xs: 'center',
                        md: 'flex-start',
                      },
                    }}
                    gap={3}
                  >
                    {LINKS.map((link, i) => (
                      <Grid key={i} size={{ xs: 12, md: 3 }}>
                        <Grid
                          container
                          direction="column"
                          gap={3}
                          sx={{
                            alignItems: { xs: 'center', md: 'flex-start' },
                          }}
                        >
                          <Box>
                            <Typography
                              variant="overline"
                              color="white"
                              textAlign={{ xs: 'center', md: 'left' }}
                            >
                              {link.headline}
                            </Typography>
                          </Box>
                          <Grid
                            container
                            direction="column"
                            gap={2}
                            sx={{
                              alignItems: { xs: 'center', md: 'flex-start' },
                            }}
                          >
                            {link.children.map((item, ii) => (
                              <Link href={item.href} underline="hover" key={ii}>
                                <Typography
                                  variant="body2"
                                  color="white"
                                  textAlign={{ xs: 'center', md: 'left' }}
                                >
                                  {item.name}
                                </Typography>
                              </Link>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              <Divider
                sx={{
                  background: 'var(--secondary-main, #FEFE01)',
                  marginTop: '24px',
                  marginBottom: '24px',
                }}
              />
              <Grid
                container
                gap={{ xs: 3, md: 0 }}
                direction={{ xs: 'column-reverse', md: 'row' }}
                alignItems={{ xs: 'center', md: 'flex-start' }}
              >
                <Grid size={6}>
                  <Typography variant="body2" color="white">
                    ©Copyright 2025, Puspa Jaya, All Rights Reserved
                  </Typography>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Grid
                    container
                    direction={{ xs: 'column', md: 'row' }}
                    gap={{ xs: 3, md: 3 }}
                    sx={{
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                    }}
                  >
                    <Grid container gap={1}>
                      <Phone color={secondary.main} />
                      <Typography color="white" variant="body2">
                        0721783111
                      </Typography>
                    </Grid>
                    <Grid container gap={1}>
                      <Mail color={secondary.main} />
                      <Typography color="white" variant="body2">
                        puspajaya.po@gmail.com
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
}
